module.exports = __webpack_public_path__ + "img/logo_144.5cff73e3.png";